import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ProductRow } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';
import { ActionSheetButton } from '@ionic/core';
import { ManualUpdateReason } from '@usf/ngrx-pricing';

@Component({
  selector: 'app-manual-approval',
  templateUrl: './manual-approval.component.html',
  styleUrls: ['./manual-approval.component.scss'],
})
export class ManualApprovalComponent {
  @Input() product: ProductRow;
  @Input() isOnline = true;
  @Input() screenWidth: number;
  @Input() manualApprovalButtons: ActionSheetButton[] = [];
  @Input() isTouch: boolean;
  @Input() showImage = true;

  @Output() closeManualApproval = new EventEmitter<void>();
  @Output() manualApprovalSubmit = new EventEmitter<Event>();
  @Output() reasonSelected = new EventEmitter<ManualUpdateReason>();

  @ViewChild('manualApprovalPopover')
  manualApprovalPopover: HTMLIonPopoverElement;

  manualApprovalReason: ManualUpdateReason;
  manualApprovalPopoverOpen = false;
  isMobileSheetOpen = false;

  manualApprovalDesktopButtons: ActionSheetButton[] = [
    {
      text: 'Keep competition out',
      role: 'selected',
      handler: () => {
        this.setManualApprovalReason(ManualUpdateReason.keepCompetitionOut);
      },
      cssClass: 'manual-approval-reason-button',
      data: ManualUpdateReason.keepCompetitionOut,
    },
    {
      text: 'New lines for this customer',
      role: 'selected',
      handler: () => {
        this.setManualApprovalReason(
          ManualUpdateReason.newLinesForThisCustomer,
        );
      },
      cssClass: 'manual-approval-reason-button',
      data: ManualUpdateReason.newLinesForThisCustomer,
    },
    {
      text: 'QMI - Out of market pricing',
      role: 'selected',
      handler: () => {
        this.setManualApprovalReason(ManualUpdateReason.qmi);
      },
      cssClass: 'manual-approval-reason-button',
      data: ManualUpdateReason.qmi,
    },
    {
      text: 'Other',
      role: 'selected',
      handler: () => {
        this.setManualApprovalReason(ManualUpdateReason.other);
      },
      cssClass: 'manual-approval-reason-button',
      data: ManualUpdateReason.other,
    },
  ];

  // Buttons for action sheet (mobile view) with cancel button
  get mobileActionSheetButtons(): ActionSheetButton[] {
    return [
      ...this.manualApprovalDesktopButtons,
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'cancel-button',
        handler: () => {
          this.isMobileSheetOpen = false;
        },
      },
    ];
  }

  constructor() {}

  onCloseManualApproval(event: Event) {
    event.stopPropagation();
    this.closeManualApproval.emit();
  }

  onManualApprovalSubmit(event: Event) {
    this.manualApprovalSubmit.emit(event);
  }

  handleReasonSelection(event: Event) {
    event.stopPropagation();
    if (this.isTouch) {
      this.isMobileSheetOpen = true;
    } else {
      this.manualApprovalPopover.event = event;
      this.manualApprovalPopoverOpen = true;
    }
  }

  setManualApprovalReason(reason: ManualUpdateReason) {
    this.manualApprovalReason = reason;
    this.manualApprovalPopoverOpen = false;
    this.isMobileSheetOpen = false;
    this.reasonSelected.emit(reason);
  }

  getReasonText(reason: ManualUpdateReason): string {
    const button = this.manualApprovalDesktopButtons.find(
      btn => btn.data === reason,
    );
    return button ? button.text : 'Select reason';
  }

  openMobileSheet() {
    this.isMobileSheetOpen = true;
  }
}
